export const dataJson =[
    {
        "statusCode": "Success",
        "statusMessage": "Successfully fetched lending template details.",
        "templateId": "a6096e31-27f0-4584-ac6b-5eb11039bff0",
        "templateName": "Salary Employee Template",
        "loanType": "Personal Loan",
        "employmentType": "Salaried",
        "applicationCompleted": false,
        "documentsRequired": [
            {
                "documentCategory": "KYC Proof",
                "order": 1,
                "documents": [
                    {
                        "documentType": "AADHAAR_CARD",
                        "documentLabel": "Aadhaar card",
                        "description": "Please upload your aadhar card",
                        "order": 1,
                        "isMandatory": true,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "PAN_CARD",
                        "documentLabel": "Pan card",
                        "description": "Please upload your pan card",
                        "order": 2,
                        "isMandatory": true,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": [
                    {
                        "documentType": "PASSPORT",
                        "documentLabel": "Passport",
                        "description": "Please upload your passport",
                        "order": 3,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "VOTER_ID",
                        "documentLabel": "Voter Id",
                        "description": "Please upload your voter id",
                        "order": 4,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "DRIVING_LICENSE",
                        "documentLabel": "Driving License",
                        "description": "Please upload your driving license",
                        "order": 5,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ]
            },
            {
                "documentCategory": "Address Proof",
                "order": 2,
                "documents": [
                    {
                        "documentType": "CURRENT_ADDRESS",
                        "documentLabel": "current address",
                        "description": "Please enter your current address",
                        "order": 1,
                        "isMandatory": true,
                        "inputType": "userInput",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "RATION_CARD",
                        "documentLabel": "Ration Card",
                        "description": "Please upload your ration card",
                        "order": 2,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": [
                    {
                        "documentType": "ELECTRICITY_BILL",
                        "documentLabel": "Electricity Bill",
                        "description": "Please upload your electricity bill",
                        "order": 3,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "WATER_BILL",
                        "documentLabel": "Water Bill",
                        "description": "Please upload your water bill",
                        "order": 4,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "TELEPHONE_BILL",
                        "documentLabel": "Telephone Bill",
                        "description": "Please upload your telephone bill",
                        "order": 5,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "PASSPORT",
                        "documentLabel": "Passport",
                        "description": "Please upload your passport",
                        "order": 6,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "RENTAL_AGREEMENT",
                        "documentLabel": "Rental Agreement",
                        "description": "Please upload your rental agreement",
                        "order": 7,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ]
            },
            {
                "documentCategory": "Income Proof",
                "order": 3,
                "documents": [
                    {
                        "documentType": "SALARY_SLIPS",
                        "documentLabel": "Salary Slips",
                        "description": "Please upload your last 3 months salary slips",
                        "order": 1,
                        "isMandatory": true,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": [
                    {
                        "documentType": "FORM_16",
                        "documentLabel": "Form 16",
                        "description": "Please upload your last 2 years form16",
                        "order": 2,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": 2
                    },
                    {
                        "documentType": "IT_RETURN",
                        "documentLabel": "Incometax Return",
                        "description": "Please upload your last 2 years IT returns",
                        "order": 3,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": 24,
                        "noOfYears": null
                    }
                ]
            },
            {
                "documentCategory": "Employment Proof",
                "order": 4,
                "documents": [
                    {
                        "documentType": "ANNUAL_INCOME",
                        "documentLabel": "Anual income",
                        "description": "Please enter your anual income",
                        "order": 1,
                        "isMandatory": true,
                        "inputType": "userInput",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": [
                    {
                        "documentType": "EMPLOYEMENT_OFFER_LETTER",
                        "documentLabel": "Employment Offer Letter",
                        "description": "Please upload your employment offer letter",
                        "order": 2,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "EMPLOYEMENT_ID_CARD",
                        "documentLabel": "Employment Id Card",
                        "description": "Please upload your employment id card",
                        "order": 3,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ]
            },
            {
                "documentCategory": "Financial Documents",
                "order": 5,
                "documents": [
                    {
                        "documentType": "EXISTING_LOAN_STATEMENTS",
                        "documentLabel": "Existing Loan Statements",
                        "description": "Please upload your existing loan Sanction letter",
                        "order": 1,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": []
            },
            {
                "documentCategory": "Photographs",
                "order": 6,
                "documents": [
                    {
                        "documentType": "RECENT_PHOTOGRAPHS",
                        "documentLabel": "Recent Photographs",
                        "description": "Please upload your recent passport size photograph",
                        "order": 1,
                        "isMandatory": true,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": []
            },
            {
                "documentCategory": "Business Proof",
                "order": 6,
                "documents": [
                    {
                        "documentType": "BUSINESS_REGISTRATION_CERTIFICATE",
                        "documentLabel": "Business Registration Certificate",
                        "description": "Please upload your business registration certificate",
                        "order": 1,
                        "isMandatory": true,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "BUSINESS_PAN_CARD",
                        "documentLabel": "Business Pan Card",
                        "description": "Please upload your business pan card",
                        "order": 2,
                        "isMandatory": true,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "CERTIFICATE_OF_INCORPORATION",
                        "documentLabel": "Certificate of Incorporation",
                        "description": "Please upload your Certificate of incorporation",
                        "order": 3,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    },
                    {
                        "documentType": "GST_REGISTRATION",
                        "documentLabel": "GST Registration",
                        "description": "Please upload your GST registration",
                        "order": 4,
                        "isMandatory": false,
                        "inputType": "file",
                        "noOfMonths": null,
                        "noOfYears": null
                    }
                ],
                "documentsToChooseFrom": []
            }
        ]
    }
]
